import { render, staticRenderFns } from "./CatalogingUpdaterView.vue?vue&type=template&id=191c6ee8&scoped=true&"
import script from "./CatalogingUpdaterView.vue?vue&type=script&lang=js&"
export * from "./CatalogingUpdaterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191c6ee8",
  null
  
)

export default component.exports